<template>
  <v-card>
    <v-card-title class="headline">Année incorrecte ?</v-card-title>
    <v-card-text class="text-subtitle-1">
      Si l’année affichée n’est pas correcte, merci de nous le signaler.
      <br /><br />
      Envoyez un email à :
      <a href="mailto:pierre.le_beuz@edu.devinci.fr" target="_blank"
        ><b>pierre.le_beuz@edu.devinci.fr</b></a
      >
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="$emit('close')"> Fermer </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "DialogHelpUserYear",
  data: () => ({}),
  methods: {
    problem: function () {
      //TODO: Add popup
      this.$swal.fire({
        icon: "error",
        title: "Un problème ?",
        text: "Code 65",
      });
    },
    validate: function () {
      if (this.adminMod) {
        this.$store
          .dispatch("admin/modifyUser", {
            _id: this.specificUser._id,
            firstname: this.user.firstname,
            lastname: this.user.lastname,
            year: this.user.year,
            school: this.user.school,
            dontModify: true,
          })
          .then(() => {
            this.$emit("close");
          });
      } else {
        this.$store
          .dispatch("admin/modifyUser", {
            _id: this.currentUser._id,
            firstname: this.user.firstname,
            lastname: this.user.lastname,
            year: this.user.year,
            school: this.user.school,
            dontModify: true,
          })
          .then(() => {
            this.$emit("close");
          });
      }
    },
  },
};
</script>
<style scoped>
.v-sheet {
  position: relative;
  color: #8f8f8f;
}
.v-icon,
.v-input {
  color: #8f8f8f;
}
.closeIcon {
  position: absolute;
  right: 0;
  top: 0;
}

.discord_link {
  color: inherit;
}
</style>
